import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getCopy } from '../../data/siteCopy';
import './About.css';

const About = () => {
  const { language } = useLanguage();
  const copy = getCopy(language);

  const skills = language === 'pt'
    ? ['Editorial', 'Cartaz', 'Identidade Visual', 'Motion', 'Publicidade']
    : ['Editorial', 'Poster Design', 'Visual Identity', 'Motion', 'Advertising'];

  const educationItems = language === 'pt'
    ? [
        {
          year: '2022–2025',
          title: 'Licenciatura em Design de Comunicação',
          subtitle: 'ESMAD – Escola Superior de Media Artes e Design · Instituto Politécnico do Porto',
        },
      ]
    : [
        {
          year: '2022–2025',
          title: 'Bachelor’s degree in Communication Design',
          subtitle: 'ESMAD – School of Media Arts and Design · Polytechnic Institute of Porto',
        },
      ];

  const experienceItems = language === 'pt'
    ? [
        {
          year: '2025',
          title: 'Despertar Gondomar',
          subtitle: 'Projeto freelance – Design editorial para campanha eleitoral',
        },
        {
          year: '2024',
          title: 'Estágio',
          subtitle: 'Detalhes do estágio a adicionar',
        },
      ]
    : [
        {
          year: '2025',
          title: 'Despertar Gondomar',
          subtitle: 'Freelance project – editorial design for an election campaign',
        },
        {
          year: '2024',
          title: 'Internship',
          subtitle: 'Internship details to be added',
        },
      ];

  const interdisciplinaryItems = language === 'pt'
    ? [
        {
          year: '2024',
          title: 'Product Development Project',
          subtitle: 'Projeto interdisciplinar académico – Porto Design Factory',
        },
      ]
    : [
        {
          year: '2024',
          title: 'Product Development Project',
          subtitle: 'Interdisciplinary academic project – Porto Design Factory',
        },
      ];

  return (
    <main className="about">
      <section className="about-header">
        <h1 className="about-title">{copy.about.title}</h1>
        <p className="about-role">{copy.about.role}</p>
      </section>

      <section className="about-content">
        <div className="about-grid">
          {/* Left Column - Main Info */}
          <div className="about-main">
            <div className="about-intro">
              <p>{copy.about.intro1}</p>
              <p>{copy.about.intro2}</p>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">{copy.about.workAreasTitle}</h2>
              <ul className="skills-list">
                {skills.map((skill, index) => (
                  <li key={index} className="skill-item">{skill}</li>
                ))}
              </ul>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">{copy.about.educationTitle}</h2>
              <div className="experience-list">
                {educationItems.map((item) => (
                  <div key={item.title} className="experience-item">
                    <span className="experience-year">{item.year}</span>
                    <div className="experience-content">
                      <h3>{item.title}</h3>
                      <p>{item.subtitle}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">{copy.about.experienceTitle}</h2>
              <div className="experience-list">
                {experienceItems.map((item) => (
                  <div key={item.title} className="experience-item">
                    <span className="experience-year">{item.year}</span>
                    <div className="experience-content">
                      <h3>{item.title}</h3>
                      <p>{item.subtitle}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">{copy.about.interdisciplinaryTitle}</h2>
              <div className="experience-list">
                {interdisciplinaryItems.map((item) => (
                  <div key={item.title} className="experience-item">
                    <span className="experience-year">{item.year}</span>
                    <div className="experience-content">
                      <h3>{item.title}</h3>
                      <p>{item.subtitle}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Link to="/" className="about-cta">
              {copy.about.cta}
            </Link>
          </div>

          {/* Right Column - Contact Info */}
          <div className="about-sidebar">
            <div className="contact-block">
              <h2 className="contact-block-title">{copy.about.locationTitle}</h2>
              <p>Porto, Portugal</p>
            </div>

            <div className="contact-block">
              <h2 className="contact-block-title">{copy.about.emailTitle}</h2>
              <a href="mailto:augusta.silva.design@gmail.com" className="contact-link">
                augusta.silva.design@gmail.com
              </a>
            </div>

            <div className="contact-block">
              <h2 className="contact-block-title">{copy.about.phoneTitle}</h2>
              <a href="tel:+351914941486" className="contact-link">
                +351 914 941 486
              </a>
            </div>

            <div className="contact-block">
              <h2 className="contact-block-title">Instagram</h2>
              <a 
                href="https://instagram.com/gusmagarts" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                @gusmagarts
              </a>
            </div>

            <div className="contact-block">
              <h2 className="contact-block-title">LinkedIn</h2>
              <a 
                href="https://www.linkedin.com/in/augusta-silva-design" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                augusta-silva-design
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
